import { deleteTransformationRow as deleteTransformationRowDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & { }

export const deleteTransformationRow = ({
    eventEmitter,
}: Props) => {
    deleteTransformationRowDiagram();
    eventEmitter.emit(Event.updateDataTransformation);
};
